import CommentPlatform from './CommentPlatform.js';

export default class Comment
{
    constructor({
      clientGeneratedId,
      id,
      message,
      image = null,
      platforms = [],
      isLoading = false,
      isDeleted = false,
      createdAt = new Date(),
    }) {
      this.clientGeneratedId = clientGeneratedId;
      this.id = id;
      this.message = message;
      this.image = image;
      this.platforms = platforms;
      this.isLoading = isLoading;
      this.isDeleted = isDeleted;
      this.createdAt = createdAt;

      platforms.forEach((rawData, key) => {
        this.platforms[key] = new CommentPlatform(rawData);
      })
    }

    get isSmucMessage() {
      return this.platforms.length === 1 && this.platforms[0].type === 'smuc';
    }

    get smucPlatform() {
      return this.platforms.filter(p => p.type === 'smuc')[0];
    }

    get facebookPlatform() {
      return this.platforms.filter(p => p.type.indexOf('facebook_') === 0)[0];
    }

    get isFacebookMessage() {
      return this.platforms.filter(p => p.type.indexOf('facebook_') === 0).length !== 0;
    }

    get name() {
      return this.platforms.length === 0 ? '' : this.platforms[0].name;
    }

    updateWith(comment) {
      Object.keys(comment).forEach(key => {
        this[key] = comment[key];
      });
    }
};
